import { cn } from '@utils/cn';

export const navLinkClasses = ({
  isActive,
  error,
  className,
}: {
  isActive: boolean;
  error?: boolean;
  className?: string;
}) =>
  cn(
    'hover:text-primary-500 relative block text-neutral-400',
    className,
    isActive &&
      'text-primary-500 after:h-[3px] after:bg-primary-500 after:absolute after:left-0 after:right-0 after:bottom-0',
    error &&
      'before:block before:absolute before:bottom-1 before:right-1 before:h-3 before:w-3 before:rounded-full before:bg-danger-400',
  );
